import FJS3Config from '@src/config/FJS3Config';
import { S3Client, ChecksumAlgorithm } from '@aws-sdk/client-s3';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-providers';
import { Upload } from '@aws-sdk/lib-storage';

let _s3Client = null;

export async function getS3Client() {
    if (_s3Client) return _s3Client;

    _s3Client = new S3Client({
        region: FJS3Config.BUCKET_REGION,
        apiVersion: 'latest',
        credentials: fromCognitoIdentityPool({
            identityPoolId: FJS3Config.IDENTITY_POOL_ID,
        }),
    });
    return _s3Client;
}

export async function getS3Upload() {
    return Upload;
}

export async function getS3ChecksumAlgorithm() {
    return ChecksumAlgorithm;
}
